export enum Margins {
  TINY = 4,
  SMALL = 8,
  MEDIUM = 16,
  LARGE = 24,
  XLARGE = 34,
  XXLARGE = 70,
}

export enum Colors {
  OFFWHITE = '#F8F8F8',
  WHITE = 'white',
  BLACK = 'black',
  LIGHT_GRAY = '#CCCCCC',
  BLUE = '#4A89F3',
  DARK_GRAY = '#a9a9a9',
  YELLOW = '#ffdd00',
  PURPLE = '#800180',
  GREEN = '#42f54e',
  RED = '#FF0000',
  ORANGE = '#EDAE00',
}

export const FANCY_SCROLLBAR = `
  
  &:hover::-webkit-scrollbar {
    display: block;
    opacity: 1;
  }

  &::-webkit-scrollbar,
  .scrollable-y::-webkit-scrollbar {
    display: block;
    opacity: 0;
    width: 6px;
    height: 6px;
  }

  &:hover::-webkit-scrollbar {
    display: block;
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(124, 136, 148, 1);
  }

  &::-webkit-scrollbar-track {
  }

`
export const NESTED_FANCY_SCROLLBAR = `

  &:hover::-webkit-scrollbar {
    display: block;
    opacity: 1;
  }

  &::-webkit-scrollbar,
  .scrollable-y::-webkit-scrollbar {
    display: block;
    opacity: 0;
    width: 6px;
    height: 6px;
  }

  &:hover::-webkit-scrollbar {
    display: block;
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(167, 176, 185, 1);
  }

  &::-webkit-scrollbar-track {
  }
`

export const showUpDownArrows = `
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: 'Always Show Up/Down Arrows';
    opacity: 1;
  }
`
